import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Component } from 'react';

import Card from './Card';
import { ColorProps } from './Helpers';

export default class PlainText extends Component {
  render() {
    const {
      align,
      ancestorImitatesLink,
      backgroundColor,
      bodyFontSize,
      className,
      copy,
      header,
      links,
      overlayColor,
      richTextCopy,
      textColor,
      verticalAlign,
      points,
      columnWidths,
      styles,
    } = this.props;

    const plainTextLinks = links?.map((link) => ({
      ...link,
      className: link.className || 'link',
    }));

    return (
      <Card
        align={align}
        ancestorImitatesLink={ancestorImitatesLink}
        backgroundColor={backgroundColor}
        bodyFontSize={bodyFontSize || 'XL'}
        className={classNames('plain-text-wrapper', className)}
        columnWidths={columnWidths}
        copy={copy}
        header={header}
        key={2}
        links={plainTextLinks}
        overlayColor={overlayColor}
        richTextCopy={richTextCopy}
        textColor={textColor}
        verticalAlign={verticalAlign}
        points={points}
        styles={styles}
      />
    );
  }
}

PlainText.defaultProps = {
  collections: [],
  hideDetails: false,
  hideShoppingLink: false,
  hideColorPicker: false,
};

const productCollectionItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  item: PropTypes.shape({}),
  sku: PropTypes.string,
});

const productCollectionShape = PropTypes.shape({
  productCollectionItems: PropTypes.arrayOf(productCollectionItemShape),
});

PlainText.propTypes = {
  align: PropTypes.string,
  backgroundColor: ColorProps,
  collections: PropTypes.arrayOf(productCollectionShape),
  copy: PropTypes.string,
  header: PropTypes.string,
  links: PropTypes.array,
  overlayColor: PropTypes.object,
  textColor: PropTypes.object,
  verticalAlign: PropTypes.string,
  richTextCopy: PropTypes.shape({
    markdown: PropTypes.string,
  }),
};
